/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HistoricalData/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'



/** @type {import('Simple/types.js').View} */
export default function HistoricalData({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category/Questions/Question/Actions/ShowHistoryAction/Content/Content/HistoricalData"
  
}) {
let questionHistoricalDataValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'historical_data',
format: fromHelpers.useTableData,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TableX
  viewPath={`${viewPath}/TableX`}
 backgroundColorRow={dtColorsWhite}
 data="question.historical_data"
 format="helpers.js useTableData"
 value={questionHistoricalDataValueData}
 heightHeader={48}
 heightRow={48}
/>
{children}
</React.Fragment>)
}